export function clockin (form, employeeId, options = {}) {
	return form.post(`/employees/${employeeId ?? form.employeeId}/device/check-in`, options);
}

export function clockout (form, employeeId, options = {}) {
	return form.post(`/employees/${employeeId ?? form.employeeId}/device/check-out`, options);
}

export function pause (form, employeeId, options = {}) {
	return form.post(`/employees/${employeeId ?? form.employeeId}/device/pause`, options);
}

export function offline (form, options = {}) {
	return form.post(`schedule/v1/devices/${form.deviceId}/checks/offline/access-code`, {
		...options,
		namespace: 'private',
	});
}

export function uploadClockDocument (form, clockId, options = {}) {
	return form.post(`/checks/${clockId}/documents`, {
		forceFormData: true,
		...options,
	});
}
